var map = {
	"./App": 44037,
	"./App.vue": 44037,
	"./assets/about/Group.png": 91125,
	"./assets/about/Group2.png": 8693,
	"./assets/about/Group3.png": 6063,
	"./assets/about/food.png": 28332,
	"./assets/about/food2.jpeg": 77094,
	"./assets/about/pay.png": 46481,
	"./assets/about/people.png": 70517,
	"./assets/about/people2.png": 77282,
	"./assets/about/title.png": 44507,
	"./assets/about/title2.png": 43205,
	"./assets/about/title3.png": 20977,
	"./assets/about/title4.png": 20141,
	"./assets/baozang.gif": 29083,
	"./assets/browse/off-icon.png": 71070,
	"./assets/browse/search_icon.png": 43216,
	"./assets/browse/shop_car_empty.png": 41700,
	"./assets/contact/add.png": 84235,
	"./assets/contact/email.png": 4021,
	"./assets/contact/icon1.png": 1547,
	"./assets/contact/icon2.png": 74026,
	"./assets/contact/icon3.png": 65271,
	"./assets/contact/icon4.png": 82884,
	"./assets/contact/icon5.png": 20063,
	"./assets/contact/icon6.png": 73747,
	"./assets/contact/icon7.png": 62852,
	"./assets/contact/icon8.png": 52994,
	"./assets/contact/phone.png": 65545,
	"./assets/contact/wx.png": 86653,
	"./assets/contact/x.png": 93727,
	"./assets/cuisine/Asian/Asian1.png": 41743,
	"./assets/cuisine/Asian/Asian2.png": 74497,
	"./assets/cuisine/Asian/Asian3.png": 99246,
	"./assets/cuisine/Burgers/burgers1.png": 31646,
	"./assets/cuisine/Burgers/burgers2.png": 91352,
	"./assets/cuisine/Burgers/burgers3.png": 76317,
	"./assets/cuisine/Chinese/Chinese1.png": 41507,
	"./assets/cuisine/Chinese/Chinese2.png": 20165,
	"./assets/cuisine/Chinese/Chinese3.png": 11047,
	"./assets/cuisine/Indian/img1.png": 28883,
	"./assets/cuisine/Indian/img2.png": 6012,
	"./assets/cuisine/Indian/img3.png": 80543,
	"./assets/cuisine/Japanese/Japanese1.png": 80944,
	"./assets/cuisine/Japanese/Japanese2.png": 66233,
	"./assets/cuisine/Japanese/Japanese3.png": 1841,
	"./assets/cuisine/Kebabs/Kebabs1.png": 28698,
	"./assets/cuisine/Kebabs/Kebabs2.png": 40553,
	"./assets/cuisine/Korean/Korean1.png": 67475,
	"./assets/cuisine/Korean/Korean2.png": 22111,
	"./assets/cuisine/Korean/Korean3.png": 81347,
	"./assets/cuisine/Pizza/Pizza1.png": 30697,
	"./assets/cuisine/Pizza/Pizza2.png": 21411,
	"./assets/cuisine/Pizza/Pizza3.png": 64129,
	"./assets/cuisine/Thai/Thai1.png": 27375,
	"./assets/cuisine/Thai/Thai2.png": 75053,
	"./assets/cuisine/Thai/Thai3.png": 52715,
	"./assets/cuisine/cuisine_bg_1.png": 8823,
	"./assets/cuisine/cuisine_bg_2.png": 47473,
	"./assets/cuisine/cuisine_bg_3.png": 90375,
	"./assets/cuisine/cuisine_bg_4.png": 88619,
	"./assets/cuisine/cuisine_desc_demo.png": 29291,
	"./assets/flag/Flag_of_Portugal.png": 27822,
	"./assets/flag/Romania.png": 74837,
	"./assets/flag/Sweden.png": 87657,
	"./assets/flag/a-Austriaaodiliguoqi.png": 58100,
	"./assets/flag/a-Belgiumbilishiguoqi.png": 36894,
	"./assets/flag/a-Danmarkdanmaiguoqi.png": 68600,
	"./assets/flag/a-Finlandfenlanguoqi.png": 48503,
	"./assets/flag/a-Greekxilaguoqi.png": 88186,
	"./assets/flag/a-Holandhelanguoqi.png": 39522,
	"./assets/flag/a-Irelandaierlanguoqi.png": 55717,
	"./assets/flag/a-Italyyidaliguoqi.png": 83546,
	"./assets/flag/a-Norwaynuoweiguoqi.png": 8799,
	"./assets/flag/a-Swedenruidianguoqi.png": 18644,
	"./assets/flag/america.png": 17726,
	"./assets/flag/aodaliya.png": 73402,
	"./assets/flag/bingdao.png": 31030,
	"./assets/flag/canada.png": 16002,
	"./assets/flag/china.png": 86420,
	"./assets/flag/deguoguoqi.png": 55700,
	"./assets/flag/france.png": 50342,
	"./assets/flag/hungary.png": 72870,
	"./assets/flag/maerta.png": 76911,
	"./assets/flag/poland.png": 8222,
	"./assets/flag/ruishi.png": 30159,
	"./assets/flag/saipulusi.png": 67406,
	"./assets/flag/siluofake.png": 62404,
	"./assets/flag/siluowenniya.png": 15139,
	"./assets/flag/uk.png": 19086,
	"./assets/flag/xibanyaguoqi.png": 21799,
	"./assets/icon/book_icon.png": 88263,
	"./assets/icon/facebook.png": 3659,
	"./assets/icon/facebook.svg": 28395,
	"./assets/icon/google.png": 52012,
	"./assets/icon/heart.png": 99321,
	"./assets/icon/heart_fill.png": 97786,
	"./assets/icon/icon_card.png": 57912,
	"./assets/icon/icon_cash.png": 41875,
	"./assets/icon/icon_fb.png": 77460,
	"./assets/icon/icon_ins.png": 22396,
	"./assets/icon/icon_paypal.png": 39887,
	"./assets/icon/icon_rights.png": 90685,
	"./assets/icon/icon_stripe.png": 34255,
	"./assets/icon/icon_tw.png": 2423,
	"./assets/icon/icon_viva.png": 14283,
	"./assets/icon/input_search.png": 77514,
	"./assets/icon/insta.svg": 72937,
	"./assets/icon/linkedin.png": 7328,
	"./assets/icon/linkedin.svg": 34199,
	"./assets/icon/sumb_down.png": 474,
	"./assets/icon/sumb_up.png": 18940,
	"./assets/icon/telegram.png": 35442,
	"./assets/icon/tiktok.svg": 30383,
	"./assets/icon/twitter.svg": 95218,
	"./assets/icon/whiteHeart.png": 18430,
	"./assets/icon/x.png": 20882,
	"./assets/icon/youyube.svg": 1198,
	"./assets/iconfont/iconfont": 99689,
	"./assets/iconfont/iconfont.css": 48793,
	"./assets/iconfont/iconfont.js": 99689,
	"./assets/iconfont/iconfont.json": 13469,
	"./assets/iconfont/iconfont.ttf": 30583,
	"./assets/iconfont/iconfont.woff": 92443,
	"./assets/iconfont/iconfont.woff2": 31733,
	"./assets/images/cuiseNot.png": 82301,
	"./assets/images/discount.png": 28109,
	"./assets/images/download_modal_bg.png": 34341,
	"./assets/images/food.png": 85140,
	"./assets/images/google_download.png": 86481,
	"./assets/images/img_home.png": 4103,
	"./assets/images/ios_download.png": 6919,
	"./assets/images/live_chat.png": 88981,
	"./assets/images/location.png": 14752,
	"./assets/images/login_bg.png": 20168,
	"./assets/images/menu-cuise.png": 37881,
	"./assets/images/mobile_banner.png": 995,
	"./assets/images/notfoundBg.png": 49465,
	"./assets/images/order_tips_download.jpg": 19385,
	"./assets/images/profile_default.png": 89809,
	"./assets/images/quotation.png": 37614,
	"./assets/images/right.png": 9602,
	"./assets/images/search.png": 17561,
	"./assets/images/skiLogo.png": 23857,
	"./assets/images/special.png": 69861,
	"./assets/index/app_download_bg.png": 7462,
	"./assets/index/download_index_mobile.png": 31824,
	"./assets/index/icon_index_1.png": 91793,
	"./assets/index/icon_index_2.png": 22973,
	"./assets/index/icon_index_3.png": 78256,
	"./assets/index/icon_index_cate2.png": 44938,
	"./assets/index/icon_index_cate3.png": 77797,
	"./assets/index/index_card.png": 6000,
	"./assets/logo-merchant.png": 42171,
	"./assets/logo.png": 66949,
	"./assets/menu/Shop_light.png": 55523,
	"./assets/menu/empty_cart.png": 4464,
	"./assets/menu/empty_cart2.png": 88756,
	"./assets/menu/empty_cart3.png": 42737,
	"./assets/menu/fhrs_0_en-gb.jpg": 71270,
	"./assets/menu/fhrs_1_en-gb.jpg": 51507,
	"./assets/menu/fhrs_2_en-gb.jpg": 43779,
	"./assets/menu/fhrs_3_en-gb.jpg": 8891,
	"./assets/menu/fhrs_4_en-gb.jpg": 67091,
	"./assets/menu/fhrs_5_en-gb.jpg": 71266,
	"./assets/menu/fhrs_AI_en-gb.jpg": 40,
	"./assets/menu/fhrs_IR_en-gb.jpg": 65974,
	"./assets/menu/fhrs_P_en-gb.jpg": 25870,
	"./assets/menu/fhrs_pass_en-gb.jpg": 48778,
	"./assets/menu/icon_bounds.png": 17404,
	"./assets/menu/icon_eur.png": 42088,
	"./assets/menu/menu_bg_1.png": 87573,
	"./assets/menu/menu_bg_2.png": 27567,
	"./assets/menu/menu_bg_3.png": 70808,
	"./assets/menu/modal_delivery.png": 24513,
	"./assets/menu/modal_dinein.png": 27580,
	"./assets/menu/modal_pickup.png": 77264,
	"./assets/menu/price-fill.svg": 30194,
	"./assets/merchant_pageloading.gif": 70435,
	"./assets/page_loading.gif": 9635,
	"./assets/points/award.png": 88886,
	"./assets/points/point.png": 26951,
	"./assets/policy/faqs_bg.png": 44041,
	"./components/BrowseComps/AddressSearchInput": 1251,
	"./components/BrowseComps/AddressSearchInput.vue": 1251,
	"./components/BrowseComps/BrowseMerchantBox": 54570,
	"./components/BrowseComps/BrowseMerchantBox.vue": 54570,
	"./components/BrowseComps/BrowseSortBox": 28430,
	"./components/BrowseComps/BrowseSortBox.vue": 28430,
	"./components/BrowseComps/ChooseAddressModal": 61201,
	"./components/BrowseComps/ChooseAddressModal.vue": 61201,
	"./components/BrowseComps/TagBar": 73337,
	"./components/BrowseComps/TagBar.vue": 73337,
	"./components/CheckoutComps/AddressBox": 70232,
	"./components/CheckoutComps/AddressBox.vue": 70232,
	"./components/CheckoutComps/CheckLoginBlock": 26427,
	"./components/CheckoutComps/CheckLoginBlock.vue": 26427,
	"./components/CheckoutComps/CheckoutCartBox": 97019,
	"./components/CheckoutComps/CheckoutCartBox.vue": 97019,
	"./components/CheckoutComps/DateTimePicker": 17189,
	"./components/CheckoutComps/DateTimePicker.vue": 17189,
	"./components/CheckoutComps/PaymentBox": 86020,
	"./components/CheckoutComps/PaymentBox.vue": 86020,
	"./components/CloudFlareVerify": 22379,
	"./components/CloudFlareVerify.vue": 22379,
	"./components/CooikeDiv": 17874,
	"./components/CooikeDiv.vue": 17874,
	"./components/CustomerService": 45127,
	"./components/CustomerService.vue": 45127,
	"./components/DownloadAppModal": 10542,
	"./components/DownloadAppModal.vue": 10542,
	"./components/Footer": 20306,
	"./components/Footer.vue": 20306,
	"./components/Header": 78465,
	"./components/Header.vue": 78465,
	"./components/IndexComps/CategoryIndex": 18633,
	"./components/IndexComps/CategoryIndex.vue": 18633,
	"./components/IndexComps/DownloadBox": 42344,
	"./components/IndexComps/DownloadBox.vue": 42344,
	"./components/IndexComps/FaqsBox": 21276,
	"./components/IndexComps/FaqsBox.vue": 21276,
	"./components/IndexComps/MerchantBox": 44355,
	"./components/IndexComps/MerchantBox.vue": 44355,
	"./components/JudgeScreenMask": 19885,
	"./components/JudgeScreenMask.vue": 19885,
	"./components/LoadErrorModal": 65529,
	"./components/LoadErrorModal.vue": 65529,
	"./components/MenuComps/CartBox": 43003,
	"./components/MenuComps/CartBox.vue": 43003,
	"./components/MenuComps/CategoryBox": 10095,
	"./components/MenuComps/CategoryBox.vue": 10095,
	"./components/MenuComps/MenuBox": 47466,
	"./components/MenuComps/MenuBox.vue": 47466,
	"./components/MenuComps/MerchantOffMobile": 51136,
	"./components/MenuComps/MerchantOffMobile.vue": 51136,
	"./components/MenuComps/ShopStatus": 2430,
	"./components/MenuComps/ShopStatus.vue": 2430,
	"./components/MerchantItem": 7361,
	"./components/MerchantItem.vue": 7361,
	"./components/MyComps/Account": 38209,
	"./components/MyComps/Account.vue": 38209,
	"./components/MyComps/Address": 58199,
	"./components/MyComps/Address.vue": 58199,
	"./components/MyComps/Booking": 74395,
	"./components/MyComps/Booking.vue": 74395,
	"./components/MyComps/Favorite": 76641,
	"./components/MyComps/Favorite.vue": 76641,
	"./components/MyComps/Orders": 75792,
	"./components/MyComps/Orders.vue": 75792,
	"./components/MyComps/Points": 80840,
	"./components/MyComps/Points.vue": 80840,
	"./components/PageLoading": 71616,
	"./components/PageLoading.vue": 71616,
	"./components/PhoneBtn": 92245,
	"./components/PhoneBtn.vue": 92245,
	"./components/Verifition/Verify": 15592,
	"./components/Verifition/Verify.vue": 15592,
	"./components/Verifition/Verify/VerifyPoints": 68572,
	"./components/Verifition/Verify/VerifyPoints.vue": 68572,
	"./components/Verifition/Verify/VerifySlide": 20535,
	"./components/Verifition/Verify/VerifySlide.vue": 20535,
	"./components/Verifition/api": 75398,
	"./components/Verifition/api/": 75398,
	"./components/Verifition/api/index": 75398,
	"./components/Verifition/api/index.js": 75398,
	"./components/Verifition/utils/ase": 50587,
	"./components/Verifition/utils/ase.js": 50587,
	"./components/Verifition/utils/util": 86978,
	"./components/Verifition/utils/util.js": 86978,
	"./config": 61073,
	"./config/": 61073,
	"./config/index": 61073,
	"./config/index.js": 61073,
	"./main": 50866,
	"./main.js": 50866,
	"./mixins/judgeScreenH5": 47932,
	"./mixins/judgeScreenH5.js": 47932,
	"./request": 97344,
	"./request/": 97344,
	"./request/index": 97344,
	"./request/index.js": 97344,
	"./router": 1120,
	"./router/": 1120,
	"./router/index": 1120,
	"./router/index.js": 1120,
	"./utils/app": 38096,
	"./utils/app.js": 38096,
	"./utils/bus": 80333,
	"./utils/bus.js": 80333,
	"./utils/debounce": 56171,
	"./utils/debounce.js": 56171,
	"./utils/getPickTimeList": 64751,
	"./utils/getPickTimeList.js": 64751,
	"./utils/jsencrypt": 41051,
	"./utils/jsencrypt.js": 41051,
	"./utils/judgeUseGoogle": 60516,
	"./utils/judgeUseGoogle.js": 60516,
	"./utils/manageCart": 50708,
	"./utils/manageCart.js": 50708,
	"./utils/payment": 11974,
	"./utils/payment.js": 11974,
	"./views": 84319,
	"./views/": 84319,
	"./views/404": 43272,
	"./views/404.vue": 43272,
	"./views/about": 28567,
	"./views/about/": 28567,
	"./views/about/components/BoxFive": 55290,
	"./views/about/components/BoxFive.vue": 55290,
	"./views/about/components/BoxFour": 57202,
	"./views/about/components/BoxFour.vue": 57202,
	"./views/about/components/BoxOne": 11504,
	"./views/about/components/BoxOne.vue": 11504,
	"./views/about/components/BoxSix": 34337,
	"./views/about/components/BoxSix.vue": 34337,
	"./views/about/components/BoxThree": 67610,
	"./views/about/components/BoxThree.vue": 67610,
	"./views/about/components/BoxTwo": 17859,
	"./views/about/components/BoxTwo.vue": 17859,
	"./views/about/index": 28567,
	"./views/about/index.vue": 28567,
	"./views/browse/browse": 41047,
	"./views/browse/browse.vue": 41047,
	"./views/category": 51341,
	"./views/category/": 51341,
	"./views/category/foodInfo": 62808,
	"./views/category/foodInfo.js": 62808,
	"./views/category/index": 51341,
	"./views/category/index.vue": 51341,
	"./views/checkout": 31158,
	"./views/checkout.vue": 31158,
	"./views/contact": 84639,
	"./views/contact/": 84639,
	"./views/contact/index": 84639,
	"./views/contact/index.vue": 84639,
	"./views/demo": 95717,
	"./views/demo.vue": 95717,
	"./views/develop": 50943,
	"./views/develop/": 50943,
	"./views/develop/index": 50943,
	"./views/develop/index.vue": 50943,
	"./views/index": 84319,
	"./views/index.vue": 84319,
	"./views/login": 54063,
	"./views/login.vue": 54063,
	"./views/menu": 624,
	"./views/menu.vue": 624,
	"./views/my/editAddress": 90785,
	"./views/my/editAddress.vue": 90785,
	"./views/my/my": 77760,
	"./views/my/my.vue": 77760,
	"./views/my/mySecond": 73363,
	"./views/my/mySecond.vue": 73363,
	"./views/payment/appPayCenter": 92697,
	"./views/payment/appPayCenter.vue": 92697,
	"./views/payment/guavaPay": 63807,
	"./views/payment/guavaPay.vue": 63807,
	"./views/payment/orderSuccess": 132,
	"./views/payment/orderSuccess.vue": 132,
	"./views/payment/payDelay": 16962,
	"./views/payment/payDelay.vue": 16962,
	"./views/payment/payFail": 65164,
	"./views/payment/payFail.vue": 65164,
	"./views/payment/paypal": 97029,
	"./views/payment/paypal.vue": 97029,
	"./views/payment/paypalAdvance": 36099,
	"./views/payment/paypalAdvance.vue": 36099,
	"./views/payment/stripe": 33181,
	"./views/payment/stripe.vue": 33181,
	"./views/payment/trustPayment": 44212,
	"./views/payment/trustPayment.vue": 44212,
	"./views/payment/trustPaymentJs": 8314,
	"./views/payment/trustPaymentJs.vue": 8314,
	"./views/payment/vivaWallet": 13548,
	"./views/payment/vivaWallet.vue": 13548,
	"./views/policy/cookiePolicy": 8727,
	"./views/policy/cookiePolicy.vue": 8727,
	"./views/policy/faqs": 32731,
	"./views/policy/faqs.vue": 32731,
	"./views/policy/private": 28442,
	"./views/policy/private.vue": 28442,
	"./views/policy/refundAndCancellations": 83094,
	"./views/policy/refundAndCancellations.vue": 83094,
	"./views/policy/termsAndConditions": 36112,
	"./views/policy/termsAndConditions.vue": 36112,
	"./views/quick/quickLogin": 7452,
	"./views/quick/quickLogin.vue": 7452,
	"./views/review": 57332,
	"./views/review.vue": 57332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;